<button #button type="button" [attr.popovertarget]="popoverId">
  <ng-content select="[buttonContent]"/>
  <icon type="drop_down"/>
</button>

<div #menu class="menu-popover" popover [id]="popoverId" (beforetoggle)="beforeToggle(button, menu)">
  <div class="button-menu" (click)="menu.hidePopover()">
    <ng-content/>
  </div>
</div>
